<template>
    <div>
        <div>
            <input type="hidden" name="_token" :value="csrf">
            <input name="qualificationsApplicant[person_id]" type="hidden" v-model="this.person_id">
            
            <div class="row">
                <div class="col-5 form-group">
                    <div>
                        <label class="out-form-label">{{ __('misc.select2') }} {{__("forms.QualificationsPerson.abilitation")}}</label>
                        <select v-model="selectedQualification" class="form-control" style="width: 100%;">
                            <option disabled value="">{{ __('misc.select') }}</option>
                            <option v-for="(qualification,index) in qualifications" :value="index" :key="index"> {{qualification}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-5 form-group">
                    <div>
                        <label class="out-form-label">{{__("forms.QualificationsPerson.abilitation_date")}}</label>
                        <input class="form-control out-form-input" v-model="newAchievedAt" type="date">
                    </div>
                </div>

                <div class="col-2 form-group">
                    <button @click="addRowQualification" class="btn btn--green mt-4" type="button">{{ __('misc.add')
                    }}</button>
                </div>

            </div>
            
            
            <div class="row">
                <div class="col-12 form-group">
                    <table class="table table-condensed ">
                        <thead class="skills-table-head">
                            <tr>
                                <th class="skills-table-head-title">{{__("forms.QualificationsPerson.abilitation")}}</th>
                                <th class="skills-table-head-title">{{__("forms.QualificationsPerson.abilitation_date")}}</th>
                                <th class="skills-table-head-title text-center">{{ __('misc.actions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="(row,index) in qualificationsGet" :key="index">
                                <td>
                                    <select :name="'qualificationApplicant['+index+'][qualification_id]'" @change="updateQualification(row,$event)" v-model="row.qualification_id" class="form-control " style="width: 100%;">
                                        <option disabled value="">{{ __('misc.select') }}</option>
                                        <option v-for="(qualification,index) in qualifications" :value="index" :key="index"> {{qualification}}</option>
                                    </select>
                                </td>
                                <td>
                                    <input :name="'qualificationApplicant['+index+'][achieved_at]'" @change="updateQualification(row,$event)" type="date" v-model="row.achieved_at" class="form-control out-form-input" style="width: 100%;">
                                </td>
                                <td class="d-flex justify-content-center">
                                    <button type="button" class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1 hrt-button float-right" @click="rmRowQualification(row)" >
                                        <i class="fas fa-trash"></i>
                                    </button>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>        
        </div>
    </div>
</template>

<style>

.skills-table-head-title {
    color: #1767A2 !important;
    font-weight: 800 !important;
}
</style>

<script>
export default {
    methods: {
        getApplications(){
            axios.get("/person-qualifications"+this.userUrl+"/"+this.person_id)
            .then((response) => {
                this.qualificationsGet  = response.data.qualifications;
                this.action     = response.data.action;
            });
        },
        updateQualification(row,event){
            
            axios.put("/qualifications-person"+this.userUrl+"/"+row.id,
            {
                qualificationsPerson : {
                    person_id : this.person_id,
                    qualification_id : row.qualification_id,
                    achieved_at : row.achieved_at
                }
            })
            .then((response) => {
                this.getApplications();
            });
        },
        rmRowQualification(row){
            
            //Delete element
            axios.delete("/qualifications-person"+this.userUrl+"/"+row.id)
            .then((response) => {
                this.getApplications();
            });
        },
        addRowQualification(){
            
            //Check if
            if ( this.selectedQualification ==='' || this.newAchievedAt ==''){
                alert("Non puoi lasciare campi vuoti");
                return;
            }
            let postData = {
                qualificationsPerson : {
                    person_id : this.person_id,
                    qualification_id : this.selectedQualification,
                    achieved_at : this.newAchievedAt
                }
            } ;
            axios.post('/qualifications-person'+this.userUrl, postData)
            .then(response => {
                this.getApplications();
            });
        },
    },
    mounted() {
        this.getApplications();
    },
    data()  {
        return {
            action : "",
            selectedQualification : "",
            newAchievedAt : "",
            qualificationsGet : null,
            userUrl : (this.is_admin) ? '' : '-user',
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    props: {
        is_admin:{
            type     : Boolean,
            required : true
        },
        person_id: {
            type: Number,
            required: true
        },
        qualifications: {
            type: Array|Object,
            required: true
        }
        
    },
    
    
}
</script>

